"use client";

import Link from "next/link";
import { useParams, usePathname } from "next/navigation";
import { Suspense, useState } from "react";

function TeamMenu() {
  const list = { top: "総合成績", player: "選手一覧", "bats/team": "打撃成績一覧", "pits/team": "投手成績一覧" };
  const { year, tId } = useParams();
  const pathname = usePathname();
  const lastPathName = pathname.split("/").filter(Boolean).at(-1) || "";
  const visiblePathName = lastPathName === "team" ? pathname.split("/").slice(-2).join("/") : lastPathName;
  const [segment, setSegment] = useState(visiblePathName || "");

  return (
    <>
      {Object.entries(list).map(([key, value]) => (
        <Link
          key={"menu-" + key}
          href={`/${year}/team/${tId}/${key === "top" ? "" : key}`}
          onClick={() => setSegment(key)}
        >
          <li
            className={`${
              segment === key || (!Object.keys(list).includes(segment) && key === "top")
                ? "bg-primary text-gray-800"
                : ""
            } btn btn-sm rounded-md w-26 bg-gray-900`}
          >
            {value}
          </li>
        </Link>
      ))}
    </>
  );
}

export default function Menu() {
  return (
    <ul className="menu menu-horizontal">
      <Suspense fallback={<li className="bg-primary rounded-md">---</li>}>
        <TeamMenu />
      </Suspense>
    </ul>
  );
}
